import Ajax from '@/common/utils/ajax'

export default {
  async create(payload) {
    return Ajax.post('/api/services/order/Shipping/CreateOrUpdate', payload)
  },
  async update(payload) {
    return Ajax.post('/api/services/order/Shipping/CreateOrUpdate', payload)
  },
  async delete(id) {
    return Ajax.delete('/api/services/order/Shipping/Delete?Id=' + id)
  },
  async get(id) {
    return Ajax.get('/api/services/order/Shipping/Get?Id=' + id)
  },
  async getAll() {
    return Ajax.get('/api/services/order/Shipping/GetAll')
  },
  async getAllGrid(payload) {
    return Ajax.get('/api/services/order/Shipping/GetAllGrid', payload)
  }
}

